/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  Authentication,
  AuthenticationFromJSON,
  AuthenticationFromJSONTyped,
  AuthenticationToJSON,
} from './Authentication'

/**
 *
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
  /**
   *
   * @type {Authentication}
   * @memberof SessionResponse
   */
  authentication?: Authentication
}

export function SessionResponseFromJSON(json: any): SessionResponse {
  return SessionResponseFromJSONTyped(json, false)
}

export function SessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    authentication: !exists(json, 'authentication') ? undefined : AuthenticationFromJSON(json['authentication']),
  }
}

export function SessionResponseToJSON(value?: SessionResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    authentication: AuthenticationToJSON(value.authentication),
  }
}
